import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { instalarErrorReporter } from './lib/errorReporter';
import { supabase } from './lib/supabase';

// Captura global de errores frontend → tabla app_errors. Inicia ANTES
// del primer render para no perder errores tempranos.
instalarErrorReporter();

// Sprint 15.29 — red de seguridad para magic links de Supabase.
// Aunque el client ya está en flowType='implicit' con detectSessionInUrl=true,
// si por algún motivo el detect interno no procesa el hash, lo hacemos a mano
// ANTES del primer render. Si tiene #access_token=..., creamos la sesión
// explícita con setSession() y limpiamos el hash. Resultado: cuando React
// monta AuthContext, supabase.auth.getSession() ya devuelve la sesión nueva.
async function procesarHashMagicLink() {
  if (typeof window === 'undefined') return;
  const hash = window.location.hash;
  if (!hash || hash.length < 5) return;
  // Quitar el # inicial. Tip de Supabase: el hash viene como
  // #access_token=...&refresh_token=...&expires_in=3600&token_type=bearer&type=magiclink
  const params = new URLSearchParams(hash.replace(/^#/, ''));
  const access_token  = params.get('access_token');
  const refresh_token = params.get('refresh_token');
  const tipo          = params.get('type');
  if (!access_token || !refresh_token) return;
  // Solo procesar si parece magic link / recovery / signup — evitamos
  // pisar otros hashes legítimos de la app.
  if (tipo && !['magiclink', 'recovery', 'signup', 'invite', 'email_change'].includes(tipo)) return;
  try {
    await supabase.auth.setSession({ access_token, refresh_token });
    // Limpiar el hash para que no quede en la URL y no se reprocese al rerender.
    window.history.replaceState({}, '', window.location.pathname + window.location.search);
  } catch (err) {
    console.warn('[magic-link] setSession falló:', err?.message || err);
  }
}

// Boot async: procesar magic link (si aplica) ANTES del primer render.
// No es bloqueante para la UI — si tarda, React ya monta y AuthContext
// recibe el SIGNED_IN event después vía onAuthStateChange.
procesarHashMagicLink();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);

// Sprint 15.28 — Service worker restaurado con estrategia network-first
// para JS/CSS (timeout 1.5s + fallback a cache). El SW v11 también funciona
// como ofuscador de update: cuando hay deploy nuevo, el browser descarga
// el SW nuevo en background → al siguiente navigate, activate handler purga
// caches viejos. Push notifications siguen funcionando con el handler push.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then(() => {
        // console.info('[SW] registrado v11-network-first');
      })
      .catch((err) => {
        console.warn('[SW] error al registrar', err);
      });
  });
}
